import script from "./page-content.vue?vue&type=script&setup=true&lang=js"
export * from "./page-content.vue?vue&type=script&setup=true&lang=js"

import "./page-content.vue?vue&type=style&index=0&id=5e2d5828&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e2d5828"]])

export default __exports__